import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-simple-import-student-accounts-wrapper',
  templateUrl: './simple-import-student-accounts-wrapper.component.html',
  styleUrls: ['./simple-import-student-accounts-wrapper.component.css']
})
export class SimpleImportStudentAccountsWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
